import { Dialog } from './Dialog'
import { CopyButton } from './CopyButton'
import { Alert } from './States'

/**
 * Dialog untuk secret yang hanya ditampilkan sekali.
 *
 * Nilai secret diberikan pemanggil sebagai prop dan hidup selama dialog
 * terpasang. Setelah dialog ditutup, komponen dilepas dan nilainya tidak
 * disimpan di state mana pun, sehingga tidak bisa muncul lagi tanpa permintaan
 * baru ke server. Server juga tidak pernah mengirim ulang secret yang sama.
 */
export function SecretDialog({
  title,
  label,
  secret,
  note,
  onClose,
}: {
  title: string
  label: string
  secret: string
  note: string
  onClose: () => void
}) {
  return (
    <Dialog
      title={title}
      onClose={onClose}
      footer={
        <button type="button" className="btn btn--primary" onClick={onClose}>
          Sudah saya simpan
        </button>
      }
    >
      <Alert tone="warning">
        Nilai ini hanya tampil sekarang. Setelah dialog ditutup, server tidak bisa
        menampilkannya lagi, jadi salin dan simpan di tempat yang aman sebelum menutup.
      </Alert>

      <div className="field">
        <span className="field__label">{label}</span>
        <div className="copy-row">
          <code className="copy-row__value">{secret}</code>
          <CopyButton value={secret} label={`Salin ${label.toLowerCase()}`} />
        </div>
      </div>

      <p className="muted">{note}</p>
    </Dialog>
  )
}
